'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  inverse: _react.PropTypes.bool,
  color: _react.PropTypes.string,
  block: _react.PropTypes.bool,
  outline: _react.PropTypes.bool,
  className: _react.PropTypes.any
};

var defaultProps = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className;
  var color = props.color;
  var block = props.block;
  var inverse = props.inverse;
  var outline = props.outline;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'color', 'block', 'inverse', 'outline', 'tag']);

  var classes = (0, _classnames2.default)(className, 'card', inverse ? 'card-inverse' : false, block ? 'card-block' : false, color ? 'card' + (outline ? '-outline' : '') + '-' + color : false);

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

exports.default = Card;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Card.js
 ** module id = 154
 ** module chunks = 0
 **/